export default __webpack_public_path__ + "static/media/wp_add.84ddfeae.svg";